import React from 'react'
import Project from './Project'
export default function index() {
  return (
    <>
  
    <Project/>
   
    </>
  )
}
